<form [formGroup]="formGroup" *ngIf="showGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_checkbox">
        <div class="text_info">
          <app-label [control]="unversperrt" class="input__label">Erhöhung der Versicherungssummen für Wertsachen und Bargeld über die Basisdeckung laut Bedingungen</app-label>
          <div class="info">
            <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('HVAUFBEWAHRUNGSAFEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
          </div>
        </div>
        <div class="row">
          <div class="col col-xs-12 col-sm-12">
            <mat-checkbox formControlName="unversperrt">Unversperrt/Freiliegend bis zu € 15.000,- statt € 2.500,-</mat-checkbox>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <mat-checkbox formControlName="en0">Safe Klasse EN0 bis zu € 20.000,- statt € 10.000,-</mat-checkbox>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <mat-checkbox formControlName="en1">Safe Klasse EN1 bis zu € 65.000,- statt € 25.000,-</mat-checkbox>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <mat-checkbox formControlName="en2">Safe Klasse EN2 bis zu € 100.000,- statt € 40.000,-</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
